import React, { useState, useEffect, useRef } from "react";
import { FiSend, FiTrash2, FiMoreVertical, FiSearch, FiRefreshCw, FiMessageSquare } from "react-icons/fi";
import {
  Box,
  IconButton,
  Typography,
  CircularProgress,
  Paper,
  TextField,
  Menu,
  MenuItem,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  InputAdornment,
  Divider,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Tooltip,
} from "@mui/material";
import { FiPlus } from "react-icons/fi";
import { Modal, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const API_URL = process.env.REACT_APP_BASE_URL;
const GRADIENT = "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)";

const drawerWidth = 240;

export default function ChatApp() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [recipientId, setRecipientId] = useState("");
  const [recipientName, setRecipientName] = useState("");
  const [chatStarted, setChatStarted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [apiResponse, setApiResponse] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const messagesEndRef = useRef(null);
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [classValue, setClassValue] = useState("0");
  const [sectionValue, setSectionValue] = useState("0");
  const [selectedChatClassId, setSelectedChatClassId] = useState(null);
  const [selectedChatSectionId, setSelectedChatSectionId] = useState(null);

  const employeeId = sessionStorage.getItem("employeeId") || "";
  const authToken = sessionStorage.getItem("token") || "YOUR_AUTH_TOKEN";
  const storedClassId = sessionStorage.getItem("classId") || "0";
const storedSectionId = sessionStorage.getItem("sectionId") || "0";
const [openStudentModal, setOpenStudentModal] = useState(false);
const [studentList, setStudentList] = useState([]);
const [studentSearchTerm, setStudentSearchTerm] = useState("");
const [studentPageNumber, setStudentPageNumber] = useState(1);
const [studentPageSize, setStudentPageSize] = useState(10);
const [chatFilterClassValue, setChatFilterClassValue] = useState("0");
const [chatFilterSectionValue, setChatFilterSectionValue] = useState("0");
const [chatFilterClasses, setChatFilterClasses] = useState([]);
const [chatFilterSections, setChatFilterSections] = useState([]);

  // Parse custom date
  const parseCustomDate = (dateStr) => {
    if (dateStr instanceof Date) return dateStr;
    if (typeof dateStr !== "string") return new Date();

    const regex = /^([A-Za-z]+)\s+(\d{1,2})\s+(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2}):(\d{3})(AM|PM)?$/;
    const match = dateStr.match(regex);

    if (!match) {
      console.error("Invalid date format:", dateStr);
      return new Date();
    }

    const [, month, day, year, hour, minute, second, millisecond, period] = match;

    const monthMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
      Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11,
    };
    const monthNumber = monthMap[month];

    let hour24 = parseInt(hour, 10);
    if (period) {
      if (period === "PM" && hour24 !== 12) hour24 += 12;
      if (period === "AM" && hour24 === 12) hour24 = 0;
    }

    return new Date(
      parseInt(year, 10),
      monthNumber,
      parseInt(day, 10),
      hour24,
      parseInt(minute, 10),
      parseInt(second, 10),
      parseInt(millisecond, 10)
    );
  };

  // Format date only (no time)
  const formatDate = (dateStr) => {
    const date = parseCustomDate(dateStr);
    if (isNaN(date.getTime())) return "Invalid Date";
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Format time only
  const formatTime = (dateStr) => {
    const date = parseCustomDate(dateStr);
    if (isNaN(date.getTime())) return "";
    return date.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Check if message can be deleted (within 30 minutes)
  const canDeleteMessage = (message) => {
    if (!message.isSent && message.direction !== "Sent") return false;

    const timestamp = message.timestamp || message.sentDate;
    if (!timestamp) return false;

    const messageDate = parseCustomDate(timestamp);
    const now = new Date();
    const diffInMinutes = (now - messageDate) / (1000 * 60);

    return diffInMinutes <= 30;
  };

  // Fetch classes
  const fetchClasses = async () => {
    try {
      const response = await fetch(
        "https://wsmsv1.aidigitalsec.com/api/Teacher/GetClass",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: authToken,
          },
          body: JSON.stringify({
            teacherId: employeeId,
          }),
        }
      );
      const data = await response.json();
      if (data.data === null || data.length === 0 || data.msg === "Record Not Found") {
        setClasses([]);
      } else {
        setClasses(data);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setClasses([]);
    }
  };

  // Fetch sections
  const fetchSections = async (classId) => {
    try {
      const response = await fetch(
        "https://wsmsv1.aidigitalsec.com/api/Teacher/ddlSection_clsId",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: authToken,
          },
          body: JSON.stringify({ classId }),
        }
      );

      const data = await response.json();
      if (data.data === null || data.length === 0) {
        setSections([]);
      } else {
        setSections(data);
      }
    } catch (error) {
      console.error("Fetch sections error:", error);
      setSections([]);
    }
  };

  // Fetch initiated chats
  const initiateChat = async () => {
    try {
      const response = await fetch(`${API_URL}/Chats/GetInitiatedChats`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({
          empId: employeeId,
          classId: classValue === "0" ? 0 : classValue,
          sectionId: sectionValue === "0" ? 0 : sectionValue,
        }),
      });
      if (!response.ok) throw new Error("Failed to fetch initiated chats");
      const data = await response.json();
      setApiResponse(data);
    } catch (error) {
      console.error("Error fetching initiated chats:", error);
    }
  };

  // Handle chat selection
  const handleChatSelection = async (chat) => {
    setRecipientId(chat.studentId);
    setRecipientName(chat.studentName);
    setSelectedChatClassId(chat.classId);
    setSelectedChatSectionId(chat.sectionId);
    setChatStarted(true);
    setLoading(true);
    try {
      const payload = {
        empId: chat.studentId,
        classId: chat.classId,
        sectionId: chat.sectionId,
        // recipientId: chat.studentId,
      };
      const response = await fetch(`${API_URL}/Chats/GetMessages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Failed to fetch messages");
      const data = await response.json();
      const allMessages = [
        ...(data.sentMessages || []).map((msg) => ({
          ...msg,
          direction: "Sent",
          isSent: true,
          timestamp: parseCustomDate(msg.sentDate),
        })),
        ...(data.receivedMessages || []).map((msg) => ({
          ...msg,
          direction: "Received",
          isSent: false,
          timestamp: parseCustomDate(msg.receivedDate),
        })),
      ];
      setMessages(allMessages.sort((a, b) => a.timestamp - b.timestamp));
    } catch (error) {
      console.error("Error fetching messages:", error);
      setError("Failed to load messages. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Send a message
  const sendMessage = async () => {
    if (!recipientId || !input.trim() || !selectedChatClassId || !selectedChatSectionId) return;
    const tempId = `temp-${Date.now()}`;
    const newMessage = {
      messageId: tempId,
      isSent: true,
      direction: "Sent",
      messageText: input,
      timestamp: new Date(),
      temp: true,
    };
    setMessages((prev) => [...prev, newMessage]);
    setInput("");
    try {
      const response = await fetch(`${API_URL}/Chats/SendMessageFromTeacher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({
          senderId: employeeId,
          recipientId,
          classId: selectedChatClassId,
          sectionId: selectedChatSectionId,
          messageText: input,
        }),
      });
      if (!response.ok) throw new Error("Failed to send message");
      const serverMessage = await response.json();
      setMessages((prev) =>
        prev.map((msg) =>
          msg.messageId === tempId ? { ...msg, ...serverMessage, temp: false } : msg
        )
      );
      fetchMessages();
    } catch (error) {
      console.error("Error sending message:", error);
      setMessages((prev) =>
        prev.map((msg) =>
          msg.messageId === tempId ? { ...msg, failed: true } : msg
        )
      );
    }
  };

  // Delete a message
  const deleteMessage = async () => {
    if (!selectedMessage) return;

    const { message, index } = selectedMessage;

    if (!canDeleteMessage(message)) {
      alert("You can only delete messages within 30 minutes of sending.");
      handleCloseContextMenu();
      return;
    }

    setMessages((prev) => prev.filter((_, i) => i !== index));
    handleCloseContextMenu();

    if (message.temp) return;

    try {
      const response = await fetch(`${API_URL}/Chats/${message.messageId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
      });
      if (!response.ok) throw new Error("Failed to delete message");
    } catch (error) {
      console.error("Error deleting message:", error);
      setMessages((prev) => [...prev.slice(0, index), message, ...prev.slice(index)]);
    }
  };

  // Mark messages as read
  const markMessagesAsRead = async () => {
    try {
      const payload = { empId: employeeId };
      const response = await fetch(`${API_URL}/Chats/ReadMessage`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`Failed to mark messages as read: ${response.status}`);
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  // Fetch classes for new chat filter
const fetchClassesForNewChat = async () => {
  try {
    const response = await fetch(
      "https://wsmsv1.aidigitalsec.com/api/Teacher/GetClass",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({
          teacherId: employeeId,
        }),
      }
    );
    const data = await response.json();
    if (data.data === null || data.length === 0 || data.msg === "Record Not Found") {
      setChatFilterClasses([]);
    } else {
      setChatFilterClasses(data);
    }
  } catch (error) {
    console.error("Error fetching classes for new chat:", error);
    setChatFilterClasses([]);
  }
};

// Fetch sections for new chat filter
const fetchSectionsForNewChat = async (classId) => {
  try {
    const response = await fetch(
      "https://wsmsv1.aidigitalsec.com/api/Teacher/ddlSection_clsId",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({ classId }),
      }
    );

    const data = await response.json();
    if (data.data === null || data.length === 0) {
      setChatFilterSections([]);
    } else {
      setChatFilterSections(data);
    }
  } catch (error) {
    console.error("Fetch sections error:", error);
    setChatFilterSections([]);
  }
};

// Handle class change for new chat
const handleChatFilterClassChange = (event) => {
  const selectedClassId = event.target.value;
  setChatFilterClassValue(selectedClassId);
  setChatFilterSectionValue("0");
  setChatFilterSections([]);
  if (selectedClassId !== "0") {
    fetchSectionsForNewChat(selectedClassId);
  }
};

// Handle section change for new chat
const handleChatFilterSectionChange = (event) => {
  setChatFilterSectionValue(event.target.value);
};
 
const fetchStudentsForNewChat = async () => {
  try {
    const response = await fetch(
      "https://wsmsv1.aidigitalsec.com/api/Chats/GetParentsForNewChats_ForTeacher",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({
          teacherId: employeeId,
          classId: chatFilterClassValue === "0" ? 0 : parseInt(chatFilterClassValue, 10),
          sectionId: chatFilterSectionValue === "0" ? 0 : parseInt(chatFilterSectionValue, 10),
          searchTerm: studentSearchTerm,
          pageNumber: studentPageNumber,
          pageSize: studentPageSize,
        }),
      }
    );
    const data = await response.json();
    
    // Extract parents array from response
    if (data && data.parents && Array.isArray(data.parents)) {
      setStudentList(data.parents);
    } else {
      setStudentList([]);
    }
  } catch (error) {
    console.error("Error fetching students:", error);
    setStudentList([]);
  }
};

  // Fetch messages
  const fetchMessages = async () => {
    if (!recipientId || !selectedChatClassId || !selectedChatSectionId) return;
    setLoading(true);
    try {
      const payload = {
        empId: recipientId,
        classId: selectedChatClassId,
        sectionId: selectedChatSectionId,
        // recipientId,
      };
      const response = await fetch(`${API_URL}/Chats/GetMessages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Failed to fetch messages");
      const data = await response.json();
      const allMessages = [
        ...(data.sentMessages || []).map((msg) => ({
          ...msg,
          direction: "Sent",
          isSent: true,
          timestamp: parseCustomDate(msg.sentDate),
        })),
        ...(data.receivedMessages || []).map((msg) => ({
          ...msg,
          direction: "Received",
          isSent: false,
          timestamp: parseCustomDate(msg.receivedDate),
        })),
      ];
      setMessages(allMessages.sort((a, b) => a.timestamp - b.timestamp));
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle context menu
  const handleContextMenu = (event, message, index) => {
    event.preventDefault();
    if (!message.isSent && message.direction !== "Sent") return;
    setContextMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 });
    setSelectedMessage({ message, index });
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setSelectedMessage(null);
  };

  // Filter chats based on search
  const filteredChats = apiResponse?.initiatedChats?.filter((chat) =>
    chat.studentName.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  // Handle class change
  const handleClassChange = (event) => {
    const selectedClassId = event.target.value;
    setClassValue(selectedClassId);
    setSectionValue("0");
    if (selectedClassId !== "0") {
      fetchSections(selectedClassId);
    } else {
      setSections([]);
    }
  };

  // Handle section change
  const handleSectionChange = (event) => {
    setSectionValue(event.target.value);
  };

  // Get initials for avatar
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

 useEffect(() => {
  if (openStudentModal) {
    fetchStudentsForNewChat();
  }
}, [chatFilterClassValue, chatFilterSectionValue, studentSearchTerm, studentPageNumber, studentPageSize, openStudentModal]);

useEffect(() => {
  if (openStudentModal) {
    fetchClassesForNewChat();
  }
}, [openStudentModal]);

  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    initiateChat();
  }, [classValue, sectionValue]);

  // Effect 1: Poll messages every 5 seconds when chat is started
  useEffect(() => {
    if (chatStarted && recipientId) {
      const interval = setInterval(() => {
        fetchMessages();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [chatStarted, recipientId, selectedChatClassId, selectedChatSectionId]);

  // Effect 2: Mark messages as read every 5 seconds
  useEffect(() => {
    if (chatStarted) {
      markMessagesAsRead();
      const readInterval = setInterval(() => {
        markMessagesAsRead();
      }, 5000);
      return () => clearInterval(readInterval);
    }
  }, [chatStarted]);

  // Effect 3: Scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
   <Box component="main" sx={{ 
     width: { md: `calc(100% - ${drawerWidth}px)` },
     ml: { md: `${drawerWidth}px` },
     mt: { xs: 0, sm: '74px' },
     p: { xs: 1, md: 3 },
     display: "flex", 
     height: "80vh", 
     backgroundColor: "#f0f2f5",  
     boxShadow: "0 2px 8px rgba(0,0,0,0.15)", 
   }}>
  {/* Left Sidebar: Initiated Chats */}
  <Box
    sx={{
      width: "380px",
      backgroundColor: "#fff",
      borderRight: "1px solid #e9edef",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    }}
  >
    {/* Sidebar Header */}
    <Box
      sx={{
        background: GRADIENT,
        color: "#fff",
        p: 2.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, letterSpacing: "0.5px" }}>
        Messages
      </Typography>

      {/*<Tooltip title="Start New Chat" arrow>
    <IconButton
  onClick={() => {
    setOpenStudentModal(true);
    fetchStudentsForNewChat();
  }}
  sx={{
    color: "#fff",
    bgcolor: "rgba(255,255,255,0.2)",
    border: "1.5px solid rgba(255,255,255,0.3)",
    backdropFilter: "blur(10px)",
    "&:hover": { 
      bgcolor: "rgba(255,255,255,0.35)",
      border: "1.5px solid rgba(255,255,255,0.5)",
      transform: "scale(1.05)",
    },
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  <FiPlus size={20} strokeWidth={2.5} />
</IconButton></Tooltip> */}
<Tooltip title="Start New Chat" arrow>
  <IconButton
    onClick={() => {
      setOpenStudentModal(true);
      fetchStudentsForNewChat();
    }}
    sx={{
      width: 42,            // ✅ ADD
      height: 42,           // ✅ ADD
      borderRadius: 2,      // ✅ ADD (square with soft corners)
      padding: 0,           // ✅ ADD (oval effect remove)

      color: "#fff",
      bgcolor: "rgba(255,255,255,0.2)",
      border: "1.5px solid rgba(255,255,255,0.3)",
      backdropFilter: "blur(10px)",
      "&:hover": { 
        bgcolor: "rgba(255,255,255,0.35)",
        border: "1.5px solid rgba(255,255,255,0.5)",
        transform: "scale(1.05)",
      },
      transition: "all 0.2s ease",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    }}
  >
    <FiPlus size={20} strokeWidth={2.5} />
  </IconButton>
</Tooltip>

    </Box>

    {/* Class and Section Dropdowns */}
    <Box sx={{ p: 2, backgroundColor: "#f8f9fa", borderBottom: "1px solid #e9edef" }}>
      <Grid container spacing={1.5}>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="class-select-label">Class</InputLabel>
            <Select
              labelId="class-select-label"
              value={classValue}
              onChange={handleClassChange}
              label="Class"
              sx={{ 
                backgroundColor: "#fff", 
                borderRadius: 2,
                fontSize: "0.9rem",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.08)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.15)",
                },
              }}
            >
              <MenuItem value="0">All Classes</MenuItem>
              {classes.map((cls) => (
                <MenuItem key={cls.classId} value={cls.classId}>
                  {cls.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="section-select-label">Section</InputLabel>
            <Select
              labelId="section-select-label"
              value={sectionValue}
              onChange={handleSectionChange}
              label="Section"
              disabled={classValue === "0" || sections.length === 0}
              sx={{ 
                backgroundColor: "#fff", 
                borderRadius: 2,
                fontSize: "0.9rem",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.08)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.15)",
                },
              }}
            >
              <MenuItem value="0">All Sections</MenuItem>
              {sections.map((section) => (
                <MenuItem key={section.sectionId} value={section.sectionId}>
                  {section.sectionName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>

    {/* Search Bar */}
    <Box sx={{ p: 2, backgroundColor: "#fff", borderBottom: "1px solid #e9edef" }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Search conversations..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiSearch color="#8696a0" size={18} />
            </InputAdornment>
          ),
        }}
        sx={{
          backgroundColor: "#f0f2f5",
          borderRadius: 2,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            "& fieldset": {
              border: "none",
            },
            "&:hover": {
              backgroundColor: "#e9edef",
            },
            "&.Mui-focused": {
              backgroundColor: "#fff",
              boxShadow: "0 0 0 2px rgba(253, 160, 133, 0.2)",
            },
          },
        }}
      />
    </Box>

    {/* Chat List */}
    <List
      sx={{
        overflowY: "auto",
        flex: 1,
        p: 0,
        backgroundColor: "#fff",
      }}
    >
      {filteredChats.length > 0 ? (
        filteredChats.map((chat) => (
          <ListItem key={chat.studentId} disablePadding>
            <ListItemButton
              selected={recipientId === chat.studentId}
              onClick={() => handleChatSelection(chat)}
              sx={{
                py: 2,
                px: 2.5,
                borderBottom: "1px solid #f0f2f5",
                transition: "all 0.15s ease",
                "&:hover": {
                  backgroundColor: "#f5f6f6",
                },
                "&.Mui-selected": {
                  backgroundColor: "#f0f2f5",
                  borderLeft: "4px solid",
                  borderLeftColor: "transparent",
                  background: `linear-gradient(to right, #f0f2f5 0%, #f0f2f5 100%)`,
                  borderImage: GRADIENT,
                  borderImageSlice: 1,
                  "&:hover": {
                    backgroundColor: "#e9edef",
                  },
                },
              }}
            >
              <Avatar
                sx={{
                  width: 52,
                  height: 52,
                  mr: 2,
                  background: GRADIENT,
                  fontWeight: 600,
                  fontSize: "1.1rem",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                {getInitials(chat.studentName)}
              </Avatar>
              <ListItemText
                primary={
                  <Typography variant="body1" sx={{ fontWeight: 500, fontSize: "1rem", mb: 0.5 }}>
                    {chat.studentName}
                  </Typography>
                }
                secondary={
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: "#667781", 
                      fontSize: "0.85rem",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    
                    {chat.admissionNo}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        ))
      ) : (
        <Box sx={{ textAlign: "center", p: 6, color: "#8696a0" }}>
          <Box sx={{ mb: 2, opacity: 0.3 }}>
            <FiMessageSquare size={48} />
          </Box>
          <Typography variant="body1" sx={{ fontWeight: 500, mb: 0.5 }}>
            {searchQuery ? "No chats found" : "No conversations yet"}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
            {searchQuery ? "Try a different search" : "Start a new chat to begin messaging"}
          </Typography>
        </Box>
      )}
    </List>
  </Box>

  {/* Right: Chat Area */}
  <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    {chatStarted ? (
      <>
        {/* Chat Header */}
        <Box
          sx={{
            background: "#f0f2f5",
            borderBottom: "1px solid #e9edef",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              sx={{
                width: 44,
                height: 44,
                mr: 2,
                background: GRADIENT,
                fontWeight: 600,
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              }}
            >
              {getInitials(recipientName)}
            </Avatar>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, color: "#111b21" }}>
                {recipientName}
              </Typography>
              <Typography variant="caption" sx={{ color: "#667781", fontSize: "0.8rem" }}>
                Student
              </Typography>
            </Box>
          </Box>
          <Box>
            <IconButton 
              onClick={fetchMessages} 
              sx={{ 
                color: "#54656f",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.05)" },
              }}
            >
              <FiRefreshCw className={loading ? "animate-spin" : ""} size={20} />
            </IconButton>
          </Box>
        </Box>

        {/* Messages Area */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: 3,
            backgroundColor: "#efeae2",
            backgroundImage: `
              linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)),
              url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.02'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
            `,
          }}
        >
          {loading && messages.length === 0 ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress sx={{ color: "#fda085" }} />
            </Box>
          ) : error ? (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <Paper sx={{ p: 2, backgroundColor: "#fff3cd", display: "inline-block", borderRadius: 2 }}>
                <Typography variant="body2" color="error">
                  {error}
                </Typography>
              </Paper>
            </Box>
          ) : messages.length > 0 ? (
            messages.map((msg, index) => {
              const isSent = msg.direction === "Sent" || msg.isSent === true;
              const messageText = msg.messageText || "No text";
              const timestamp = msg.timestamp || msg.sentDate || msg.receivedDate;
              return (
                <Box
                  key={`${msg.messageId}-${index}`}
                  sx={{
                    display: "flex",
                    justifyContent: isSent ? "flex-end" : "flex-start",
                    mb: 1,
                    animation: "fadeIn 0.2s ease-in",
                    "@keyframes fadeIn": {
                      from: { opacity: 0, transform: "translateY(10px)" },
                      to: { opacity: 1, transform: "translateY(0)" },
                    },
                  }}
                >
                  <Paper
                    onContextMenu={(e) => handleContextMenu(e, msg, index)}
                    elevation={0}
                    sx={{
                      p: 1.5,
                      maxWidth: "65%",
                      backgroundColor: isSent ? "#d9fdd3" : "#fff",
                      color: "#111b21",
                      borderRadius: isSent ? "8px 8px 0px 8px" : "8px 8px 8px 0px",
                      cursor: isSent ? "context-menu" : "default",
                      boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                      position: "relative",
                      transition: "transform 0.1s ease",
                      "&:hover": {
                        transform: "scale(1.01)",
                      },
                    }}
                  >
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        mb: 0.5, 
                        wordBreak: "break-word",
                        lineHeight: 1.5,
                        fontSize: "0.95rem",
                      }}
                    >
                      {messageText}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        gap: 0.5,
                        color: "#667781",
                        fontSize: "0.7rem",
                        mt: 0.5,
                      }}
                    >
                      {formatDate(timestamp)}
                      {isSent && (
                        <Box component="span" sx={{ display: "flex", ml: 0.5 }}>
                          <svg viewBox="0 0 16 15" width="16" height="15">
                            <path fill="#53bdeb" d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"/>
                          </svg>
                        </Box>
                      )}
                    </Typography>
                  </Paper>
                </Box>
              );
            })
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#667781",
              }}
            >
              <Box sx={{ fontSize: "5rem", mb: 2, opacity: 0.2 }}>💬</Box>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 500 }}>
                No messages yet
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "0.9rem" }}>
                Start the conversation by sending a message
              </Typography>
            </Box>
          )}
          <div ref={messagesEndRef} />
        </Box>

        {/* Input Area */}
        <Box
          sx={{
            p: 2,
            backgroundColor: "#f0f2f5",
            display: "flex",
            gap: 1.5,
            alignItems: "flex-end",
            borderTop: "1px solid #e9edef",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Type a message"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && sendMessage()}
            multiline
            maxRows={4}
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2.5,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2.5,
                fontSize: "0.95rem",
                "& fieldset": {
                  border: "none",
                },
                "&:hover": {
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                },
                "&.Mui-focused": {
                  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                },
              },
            }}
          />
          <IconButton
            onClick={sendMessage}
            disabled={!input.trim()}
            sx={{
              background: input.trim() ? GRADIENT : "#d1d7db",
              color: "#fff",
              width: 48,
              height: 48,
              mb: 0.5,
              boxShadow: input.trim() ? "0 2px 8px rgba(253, 160, 133, 0.4)" : "none",
              transition: "all 0.2s ease",
              "&:hover": {
                background: input.trim() ? GRADIENT : "#d1d7db",
                transform: input.trim() ? "scale(1.05)" : "none",
                boxShadow: input.trim() ? "0 4px 12px rgba(253, 160, 133, 0.5)" : "none",
              },
              "&.Mui-disabled": {
                color: GRADIENT,
                opacity: 0.6,
              },
            }}
          >
            <FiSend size={20} />
          </IconButton>
        </Box>
      </>
    ) : (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          backgroundColor: "#f8f9fa",
          color: "#667781",
        }}
      >
        <Box
          sx={{
            width: 240,
            height: 240,
            borderRadius: "50%",
            background: `linear-gradient(135deg, rgba(253, 160, 133, 0.1) 0%, rgba(247, 140, 160, 0.1) 100%)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 4,
            border: "2px solid rgba(253, 160, 133, 0.2)",
          }}
        >
          <Box sx={{ fontSize: "6rem" }}>💬</Box>
        </Box>
        <Typography variant="h5" sx={{ mb: 1.5, fontWeight: 500, color: "#111b21" }}>
          Welcome to Messages
        </Typography>
        <Typography variant="body1" sx={{ textAlign: "center", maxWidth: 400, color: "#667781" }}>
          Select a conversation from the sidebar or start a new chat to begin messaging
        </Typography>
      </Box>
    )}
  </Box>

  {/* Context Menu */}
  <Menu
    open={contextMenu !== null}
    onClose={handleCloseContextMenu}
    anchorReference="anchorPosition"
    anchorPosition={
      contextMenu !== null
        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
        : undefined
    }
    PaperProps={{
      sx: {
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        minWidth: 180,
      }
    }}
  >
    <MenuItem
      onClick={deleteMessage}
      disabled={selectedMessage && !canDeleteMessage(selectedMessage.message)}
      sx={{
        color: selectedMessage && !canDeleteMessage(selectedMessage.message) ? "#8696a0" : "#ea4335",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        py: 1.5,
        px: 2,
        fontSize: "0.9rem",
        "&:hover": {
          backgroundColor: selectedMessage && !canDeleteMessage(selectedMessage.message) ? "transparent" : "#fee",
        },
      }}
    >
      <FiTrash2 size={16} />
      Delete message
    </MenuItem>
  </Menu>

  <Modal 
  open={openStudentModal} 
  onClose={() => setOpenStudentModal(false)}
  sx={{
    backdropFilter: 'blur(4px)',
  }}
>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: { xs: '90%', sm: 580 },
      bgcolor: "background.paper",
      boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
      borderRadius: 3,
      maxHeight: "95vh",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    }}
  >
    {/* Header with Gradient */}
    <Box
      sx={{
        background: GRADIENT,
        p: 2.5,
        position: "relative",
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
      }}
    >
      <Typography 
        variant="h6" 
        sx={{ 
          fontWeight: 600,
          color: "#fff",
          letterSpacing: "0.3px"
        }}
      >
        Select a Student
      </Typography>
      {/*<IconButton
        onClick={() => setOpenStudentModal(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "#fff",
          bgcolor: "rgba(255,255,255,0.1)",
          "&:hover": {
            bgcolor: "rgba(255,255,255,0.2)",
          },
          transition: "all 0.2s ease",
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton> */}
      <IconButton
  onClick={() => setOpenStudentModal(false)}
  sx={{
    position: "absolute",
    right: 8,
    top: 8,

    width: 36,
    height: 36,
    padding: 0,
    borderRadius: 0,        

    color: "#fff",
    bgcolor: "rgba(255,255,255,0.1)",

    zIndex: 2,              
    pointerEvents: "auto",  

    "&:hover": {
      bgcolor: "rgba(255,255,255,0.2)", 
    },

    transition: "all 0.2s ease",
  }}
>
  <CloseIcon fontSize="small" />
</IconButton>

    </Box>

    {/* Content Area */}
    <Box sx={{ p: 3, overflow: "hidden", flex: 1 }}>
      {/* Class and Section Dropdowns */}
      <Grid container spacing={2} sx={{ mb: 2.5 }}>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="chat-filter-class-label">Class</InputLabel>
            <Select
              labelId="chat-filter-class-label"
              value={chatFilterClassValue}
              onChange={handleChatFilterClassChange}
              label="Class"
              sx={{
                borderRadius: 2,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.1)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.2)",
                },
              }}
            >
              <MenuItem value="0">All Classes</MenuItem>
              {chatFilterClasses.map((cls) => (
                <MenuItem key={cls.classId} value={cls.classId}>
                  {cls.className}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="chat-filter-section-label">Section</InputLabel>
            <Select
              labelId="chat-filter-section-label"
              value={chatFilterSectionValue}
              onChange={handleChatFilterSectionChange}
              label="Section"
              disabled={chatFilterClassValue === "0" || chatFilterSections.length === 0}
              sx={{
                borderRadius: 2,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.1)",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0,0,0,0.2)",
                },
              }}
            >
              <MenuItem value="0">All Sections</MenuItem>
              {chatFilterSections.map((section) => (
                <MenuItem key={section.sectionId} value={section.sectionId}>
                  {section.sectionName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      
      {/* Search Field */}
      <TextField
        fullWidth
        size="small"
        placeholder="Search students..."
        value={studentSearchTerm}
        onChange={(e) => setStudentSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiSearch color="#667781" />
            </InputAdornment>
          ),
        }}
        sx={{ 
          mb: 2.5,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            "& fieldset": {
              borderColor: "rgba(0,0,0,0.1)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(0,0,0,0.2)",
            },
            "&.Mui-focused fieldset": {
              borderWidth: 2,
            },
          }
        }}
      />

      {/* Page Size Selector */}
      <FormControl fullWidth size="small" sx={{ mb: 2.5 }}>
        <InputLabel>Page Size</InputLabel>
        <Select
          value={studentPageSize}
          onChange={(e) => setStudentPageSize(e.target.value)}
          label="Page Size"
          sx={{
            borderRadius: 2,
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0,0,0,0.1)",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(0,0,0,0.2)",
            },
          }}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>

      {/* Student List */}
      <Box 
        sx={{ 
          border: "1px solid rgba(0,0,0,0.08)",
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "#fafafa"
        }}
      >
        <List sx={{ maxHeight: 320, overflowY: "auto", overflowX:'hidden', p: 0 }}>
          {Array.isArray(studentList) && studentList.length > 0 ? (
            studentList.map((student, index) => (
              <ListItem 
                key={student.parentEmpId} 
                disablePadding
                sx={{
                  borderBottom: index !== studentList.length - 1 ? "1px solid rgba(0,0,0,0.06)" : "none",
                }}
              >
                <ListItemButton
                  onClick={() => {
                    const chatClassId = student.classId;
                    const chatSectionId = student.sectionId;
                    
                    setRecipientId(student.parentEmpId);
                    setRecipientName(student.studentName);
                    setSelectedChatClassId(chatClassId);
                    setSelectedChatSectionId(chatSectionId);
                    setChatStarted(true);
                    setOpenStudentModal(false);
                    handleChatSelection({
                      studentId: student.parentEmpId,
                      studentName: student.studentName,
                      classId: chatClassId,
                      sectionId: chatSectionId,
                    });
                  }}
                  sx={{
                    py: 1.5,
                    px: 2,
                    bgcolor: "#fff",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      bgcolor: "#f5f5f5",
                      transform: "translateX(4px)",
                    },
                  }}
                >
                  <Avatar 
                    sx={{ 
                      width: 40, 
                      height: 40, 
                      mr: 2, 
                      background: GRADIENT,
                      fontSize: "0.95rem",
                      fontWeight: 600,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                    }}
                  >
                    {getInitials(student.studentName)}
                  </Avatar>
                  <ListItemText
                    primary={
                      <Typography 
                        sx={{ 
                          fontWeight: 500,
                          fontSize: "0.95rem",
                          color: "#1a1a1a",
                          mb: 0.5
                        }}
                      >
                        {student.studentName}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography 
                          component="span" 
                          variant="body2" 
                          sx={{ 
                            display: 'block', 
                            fontSize: '0.8rem',
                            color: "#666",
                            mb: 0.25
                          }}
                        >
                          {student.className} - {student.sectionName}
                        </Typography>
                        <Typography 
                          component="span" 
                          variant="body2" 
                          sx={{ 
                            fontSize: '0.75rem',
                            color: "#999",
                            fontWeight: 500
                          }}
                        >
                          {student.admissionNo}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))
          ) : (
            <Box sx={{ textAlign: "center", p: 6, bgcolor: "#fff" }}>
              <Typography variant="body2" sx={{ color: "#999", fontSize: "0.9rem" }}>
                {studentSearchTerm ? "No students found" : "No students available"}
              </Typography>
            </Box>
          )}
        </List>
      </Box>
    </Box>

    {/* Footer with Pagination */}
    <Box 
      sx={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        p: 2.5,
        borderTop: "1px solid rgba(0,0,0,0.08)",
        bgcolor: "#fafafa"
      }}
    >
      <Button
        disabled={studentPageNumber === 1}
        onClick={() => setStudentPageNumber((prev) => Math.max(prev - 1, 1))}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 500,
          px: 2.5,
        }}
      >
        Previous
      </Button>
      <Typography 
        sx={{ 
          fontWeight: 500,
          fontSize: "0.9rem",
          color: "#666"
        }}
      >
        Page {studentPageNumber}
      </Typography>
      <Button
        onClick={() => setStudentPageNumber((prev) => prev + 1)}
        sx={{
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 500,
          px: 2.5,
        }}
      >
        Next
      </Button>
    </Box>
  </Box>
</Modal>

</Box>
  );
}